import { debounce } from '@noths/polaris-client-utils';

import type { GroupedSuggestions } from 'client-site-chrome-ui/components/molecules/SearchSuggestions/types';
import type { Environment } from 'client-site-chrome-ui/environment';
import { fetchGoogleSearchSuggestions } from 'client-site-chrome-ui/services/search/google/fetchGoogleSearchSuggestions';
import { transformGoogleSearchSuggestions } from 'client-site-chrome-ui/services/search/google/transformGoogleSearchSuggestions';

const debouncedFetchGoogleSearchSuggestions = debounce(fetchGoogleSearchSuggestions, 200);

export const getGoogleSearchSuggestions = async (
  env: Environment,
  searchTerm: string,
  userId: string,
): Promise<GroupedSuggestions | null> => {
  const googleSuggestions = await debouncedFetchGoogleSearchSuggestions(env, searchTerm, userId);

  return googleSuggestions ? transformGoogleSearchSuggestions(googleSuggestions) : null;
};
